import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, grayIconFill, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 16,
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		backgroundColor: white,
		marginTop: 10,
		marginBottom: 16,
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 8,
	},
	statusText: {
		fontSize: 14,
		fontWeight: 600,
		margin: 0,
	},
	percentText: {
		fontSize: 14,
		color: grayIconFill,
	},
	progressBarOuter: {
		height: 8,
		borderRadius: 4,
		backgroundColor: '#e5e7eb',
		overflow: 'hidden',
		marginBottom: 8,
	},
	progressBarInner: {
		height: '100%',
		borderRadius: 4,
		backgroundColor: brandPrimary,
		transition: 'width 0.3s ease',
	},
	currentContact: {
		fontSize: 13,
		color: grayIconFill,
		margin: 0,
	},
});
